<template>
  <v-data-table
    :headers="permissionsHeaders"
    :items="value"
    item-key="name"
    :hide-default-header="$vuetify.breakpoint.smAndDown"
    hide-default-footer
    class="elevation-1"
    disable-sort
  >
    <template v-slot:item.role="{ item }">{{ item.name }}</template>
    <template
      v-slot:item.units="{ item }"
    >{{ !hasUnits(item) ? 'Todas' : joinUnitsNames(item.units) }}</template>
    <template v-slot:item.actions="{ item }">
      <v-btn icon @click="removeRole(item)">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { map } from 'lodash';
import { clone } from '@/utils';

export default {
  name: 'UserPermissionsDataTable',
  props: {
    value: {
      type: Array
    }
  },
  data() {
    return {
      permissionsHeaders: [
        { text: 'Perfil', value: 'role' },
        { text: 'Unidades', value: 'units' },
        { text: 'Ações', value: 'actions', width: '50' }
      ],
    }
  },
  methods: {
    map,
    joinUnitsNames(units) {
      return map(units, 'name').join(', ');
    },
    removeRole(role) {
      const roles = clone(this.value);
      const selectedRoleIndex = roles.findIndex(roleToFind => roleToFind.role === role.role);
      roles.splice(selectedRoleIndex, 1);
      this.$emit('input', roles);
    },
    hasUnits(role) {
      return role.units && role.units.filter(unit => unit).length
    }
  }
}
</script>

<style>
</style>